var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pega-comment area" },
    _vm._l(_vm.comments, function (value, i) {
      return _c(
        "job-preview-comment-thread",
        _vm._g(
          { key: value.id + "-" + i, attrs: { "comment-thread": value } },
          _vm.$listeners
        )
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }